export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_320000-c3e95ab9fafe29f68153dc5f7831652c.avif";